export const CAMPAIGN_OFFERS = {
  PREZAO_SHOPEE: {
    plan_base_offer: ["247031000"],
    rechargeValues: {
      2000: {
        validity: 20,
        bonus: "",
        freedomBonus: "8GB livre",
        aditionalBonus: "",
      },
      2500: {
        validity: 25,
        bonus: "",
        freedomBonus: "10GB livre",
        aditionalBonus: "",
      },
      3000: {
        validity: 25,
        bonus: "",
        freedomBonus: "12GB livre",
        aditionalBonus: "",
      },
      3500: {
        validity: 30,
        bonus: "",
        freedomBonus: "12GB livre",
        aditionalBonus: "5GB Shopee",
      },
    },
  },
  PREZAO_KWAI: {
    plan_base_offer: ["247441000"],
    rechargeValues: {
      2000: {
        validity: 20,
        bonus: "",
        freedomBonus: "8GB livre",
        aditionalBonus: "",
      },
      2500: {
        validity: 25,
        bonus: "",
        freedomBonus: "10GB livre",
        aditionalBonus: "",
      },
      3000: {
        validity: 25,
        bonus: "",
        freedomBonus: "12GB livre",
        aditionalBonus: "",
      },
      3500: {
        validity: 30,
        bonus: "",
        freedomBonus: "12GB livre",
        aditionalBonus: "5GB KWAI",
      },
    },
  },
  PREZAO_UBER: {
    plan_base_offer: ["234611000"],
    rechargeValues: {
      2000: {
        validity: 20,
        bonus: "",
        freedomBonus: "8GB livre",
        aditionalBonus: "",
      },
      2500: {
        validity: 25,
        bonus: "",
        freedomBonus: "10GB livre",
        aditionalBonus: "",
      },
      3000: {
        validity: 25,
        bonus: "",
        freedomBonus: "12GB livre",
        aditionalBonus: "",
      },
      3500: {
        validity: 30,
        bonus: "",
        freedomBonus: "12GB livre",
        aditionalBonus: "5GB UBER",
      },
    },
  },
  UM_POR_DIA_15_e_21: {
    plan_base_offer: ["260421000", "243311000"],
    rechargeValues: {
      2000: {
        validity: 20,
        bonus: "10GB de bônus",
        freedomBonus: "8GB livre",
        aditionalBonus: "2GB de Youtube",
      },
      2500: {
        validity: 25,
        bonus: "",
        freedomBonus: "10GB livre",
        aditionalBonus: "2GB de Youtube",
      },
      3000: {
        validity: 30,
        bonus: "6GB de bônus",
        freedomBonus: "12GB livre",
        aditionalBonus: "3G de Youtube",
      },
    },
  },
};
